module.exports = __webpack_public_path__ + "static/media/upload.b6af15ad.svg";